import React from 'react';
import { observer } from 'mobx-react';

// types
import { NativeProfileLockupProps } from './types';

// components
import NativeFlex from '../../Bits/NativeFlex';
import NativeIcon from '../../Bits/NativeIcon';
import {
    StyledAvatar,
    StyledNativeProfileLockup,
    StyledSecondaryName,
    StyledUserName,
} from './styledComponents';

// hooks
import { usePostClickableEntities } from '@sprinklr/display-builder/hooks/usePostClickableEntities';

// constants
import { theme } from './constants';

// helpers
import { getChannelColor } from 'components/_UI/designSystem/helpers';
import { getNativeColor } from '../../Helpers';

const NativeProfileLockup: React.FC<NativeProfileLockupProps> = ({
    profileImgUrl,
    primary,
    secondary,
    secondaryType,
    tertiary,
    showRetweet,
    snType,
    snCreatedTime,
    verified,
    pad,
    colorMode,
    clickableUrls,
    profilePermalink,
    permalink,
}) => {
    const showProfileInfo = primary || secondary || (showRetweet && tertiary);

    const { handleProfileClick, handleChannelClick } = usePostClickableEntities({
        permalink,
        clickableUrls,
        profilePermalink,
    });

    return (
        <StyledNativeProfileLockup
            between
            middle
            noGrow
            gap='m'
            pad={pad}
            right={!profileImgUrl && !primary && !secondary}>
            {profileImgUrl && (
                <StyledAvatar user={{ url: profileImgUrl }} onClick={handleProfileClick} />
            )}
            {showProfileInfo && (
                <NativeFlex between middle vertical>
                    {primary && (
                        <NativeFlex middle noGrow gap='s' onClick={handleProfileClick}>
                            <StyledUserName colorMode={colorMode}>{primary}</StyledUserName>
                            {verified && <NativeIcon size='m' value='native_twitter_verified' />}
                        </NativeFlex>
                    )}
                    {secondary && (
                        <StyledSecondaryName
                            data-testid='post-profile-secondary'
                            colorMode={colorMode}
                            onClick={
                                secondaryType === 'time' ? handleChannelClick : handleProfileClick
                            }>
                            {secondary}
                        </StyledSecondaryName>
                    )}
                    {showRetweet && tertiary && (
                        <NativeFlex middle noGrow gap='s' onClick={handleProfileClick}>
                            <NativeIcon
                                size='s'
                                value={'twitter_retweet'}
                                color={getNativeColor(theme, colorMode, 'secondary')}
                            />
                            <StyledSecondaryName
                                colorMode={
                                    colorMode
                                }>{`Repost of ${tertiary}`}</StyledSecondaryName>
                        </NativeFlex>
                    )}
                </NativeFlex>
            )}
            {snType && (
                <NativeIcon
                    size='l'
                    value={snType === 'facebook' ? 'facebook_filled' : snType}
                    color={getChannelColor({ channel: snType })}
                    onClick={handleChannelClick}
                />
            )}
        </StyledNativeProfileLockup>
    );
};

NativeProfileLockup.displayName = 'NativeProfileLockup';
export default observer(NativeProfileLockup);
